<template>
  <v-main>
    <v-container class="py-1">
      <v-row>
        <v-col cols="12" sm="7" md="6" class="py-0">
          <v-card outlined>
            <v-card flat>
              <v-card-title>
                Select Video to Upload
              </v-card-title>

              <v-card-text class="text-center">
                <v-list>
                  <v-list-item v-for="(f,i) in filestoupload" :disabled="videoprogress[i]===-1">
                    <v-list-item-action v-if="parseInt(videoprogress[i])!==-1 && ( (!videoprogress[i] && videoprogress[i]!==false)||(pauseduploads[f.newname]  && videoprogress[i]!==false) )">
                      <v-btn v-if="!videoprogress[i] && videoprogress[i]!==false" icon @click="Cancel(f.newname,i)">
                        <v-icon>{{icons.close}}</v-icon>
                      </v-btn>
                      <v-btn icon v-if="pauseduploads[f.newname]  && videoprogress[i]!==false" @click="Cancel(f.newname,i)">
                        <v-icon color="error" >{{icons.close}}</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="subtitle-2 font-weight-light"
                              v-if="videoprogress[i]!==200 && videoprogress[i]!=-1">
                        Preparing Upload
                      </span>
                        <span v-else>
                        {{ f.name }}
                      </span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <v-progressLinear v-model="videoprogress[i]" :color="videoprogress[i]==200?'success':'primary'" />
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="parseInt(videoprogress[i])===-1">Canceled</v-list-item-subtitle>
                      <v-list-item-subtitle v-else>
                        {{parseInt(videoprogress[i])||0}} % / {{ (f.size/1024/1024).toFixed(2) }} MB
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="videoprogress[i] && videoprogress[i]!==-1">
                      <v-btn icon class="float-right" v-if="!pauseduploads[f.newname] && videoprogress[i]!==200" @click="Pause(f.newname,i)">
                        <v-icon color="primary" large>{{icons.pause}}</v-icon>
                      </v-btn>
                      <v-btn icon class="float-right" v-if="pauseduploads[f.newname]" @click="Resume(f.newname,i)">
                        <v-icon color="success" large>{{icons.play}}</v-icon>
                      </v-btn>
                      <v-btn icon class="float-right" v-if="videoprogress[i]===200">
                        <v-icon color="success"  small>{{icons.thumbsup}}</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-row v-if="!videouploading">
                  <v-col>
                    <v-form ref="form">
                      <v-file-input
                              ref="file"
                              outlined
                              accept="video/*"
                              clearable
                              :show-size="1000"
                              multiple
                              @change="readfile($event)"
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip
                                  small
                                  label
                                  color="primary"
                          >
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card flat class="mb-2" v-if="1===2">
              <v-card-title>
                Tags?
              </v-card-title>
              <v-card-text>
                Would you like to tag these now?
                <v-text-field
                        v-model="grouptag"
                        label="Tag these"
                        outline
                />
              </v-card-text>
            </v-card>
          </v-card>
        </v-col>
        <v-col cols="12" sm="5" md="6" class="py-0">
          <v-card outlined flat class="pa-1">
            <v-card-title class="font-weight-light subtitle-2">Recent Uploads</v-card-title>
            <v-virtual-scroll
                    v-if="videos"
                    :items="videos"
                    :item-height="60"
                    :height="scrollHeight"
            >
              <template v-slot="{ item }">
                <v-list-item >
                  <v-list-item-action v-if="item.thumb==='loading'">
                    <v-icon>{{icons.question}}</v-icon>
                  </v-list-item-action >
                  <v-list-item-avatar tile v-else>
                    <v-img :src="thumburl+item.thumb" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title> {{item.title}}</v-list-item-title>
                    <v-list-item-subtitle> {{new Date(item.createdAt).toLocaleString()}}  {{new Date(item.createdAt).toLocaleString()}} </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>


<script>
  import Evaporate from 'evaporate'
  import AWS from 'aws-sdk'
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  export default {
    data () {
      return {
        disabled: false,
        demosrc: '',
        filenameb: 'athleteforlife',
        grouptag: '',
        filestoupload: undefined,
        uploadcontrols: {},
        filenames: [],
        pauseduploads:{},
        videos: [],
        thumburl: 'https://videos.athleteforlife.org/',
        videourl: 'https://videos.athleteforlife.org/',
        processcomplete: false
      }
    },
    mounted () {
      this.getRecent()
    },
    watch:{
      videouploading(n,o){

      }
    },
    computed: {
      ...mapState(['videoprogress','userpool','org','cognito','icons','os']),
      videodrive(){
        //return this.org.partkey
        return this.cognito.user.username
      },
      scrollHeight(){
        return (this.$vuetify.breakpoint.xsOnly) ? window.innerHeight-420 : window.innerHeight - 230
      },
      videouploading(){
        //if its been paused or is not set yet
        if(this.videoprogress===undefined)return false
        let v= this.videoprogress.every(e=>e<0)
        return !v
      }
    },
    methods: {
      ...mapActions(['post', 'get', 'openGet']),
      ...mapMutations(['setVideoProgress','resetVideoProgress']),
      test(event){
        console.log(event.length)
      },
      readfile (event) {
        this.filestoupload = event
        this.resetVideoProgress([])
        console.log(event.length)
        // this logic will help create thumbnails... need better logic for different file formats
        // var fileURL = URL.createObjectURL(files[0])
        // em.demosrc = fileURL
        if(event && event.length>0)this.save()
      },
      async save () {
        let date = new Date()
        var em = this
        var promise
        var p = []
        var files = this.filestoupload
        var filePromises = []
        var allCompleted
        this.disabled = true
        let session = await this.$store.dispatch('cognito/fetchSession');
        Evaporate.create({
          signerUrl: em.$store.state.url + 'api/mobile/signv4_authv2',
          signHeaders: {
            'Authorization': 'Bearer '+ session.accessToken.jwtToken,
            'Pool': this.userpool
          },
          aws_key: 'AKIAIERQHVC6LFNJNTVA',
          awsRegion: 'us-west-2',
          bucket: 'a4l-tmp-bucket',
          awsSignatureVersion: '4',
          computeContentMd5: true,
          cloudfront: true,
          maxConcurrentParts: 5,
          s3Acceleration:true,
          cryptoMd5Method: function (data) { return AWS.util.crypto.md5(data, 'base64') },
          cryptoHexEncodedHash256: function (data) { return AWS.util.crypto.sha256(data, 'hex') }
        }).then(async function (evaporate) {

          for (let i = 0; i < files.length; i++) {
            let d = {
              createdAt: new Date().toUTCString(),
              thumb: "loading",
              title: "...uploading",
              url720p: "...Coming",
              userId: em.videodrive
            }
            em.videos.unshift(d)
            let uuid = await em.getuuid()//gets a filename unique number
            var type = files[i].type;
            console.log('TYPE', type, files[0])
            var filename = em.videodrive + '_' + em.filenameb + '_' + uuid
            em.filestoupload[i].newname = filename
            promise = evaporate.add({
              name: filename,
              file: files[i],
              xAmzHeadersAtInitiate: {
                'x-amz-acl': 'public-read',
                'content-type': type,
                'x-amz-storage-class': 'STANDARD'
              },
              //a4l-tmp-bucket.s3-accelerate.amazonaws.com
              progress: function (progress) {
                //console.log('making progress: ' + progress)
                p = (progress * 100)
                em.setVideoProgress({key: i, value: p})
              }
            }).then(function (awsKey) {
                console.log('ALL COMPLETE ', awsKey, 'complete!')
                em.setVideoProgress({key: i, value: 200})
                em.uploadcontrols = {}

              });
            filePromises.push(promise)
            em.uploadcontrols[filename]=evaporate
          }

          allCompleted = Promise.all(filePromises)
            .then(function () {
              em.filestoupload = undefined
              em.disabled = false
              em.resetVideoProgress(['completed'])
              console.log('All files were uploaded successfully.')
              if(em.$refs.form){
                em.$refs.form.reset()
              }
              em.getRecent()
            }, function (reason) {
              console.log('All files were not uploaded successfully:', reason)
            })
        },
        function (reason) {
           console.log('Evaporate failed to initialize: ', reason)
        })
      },
      Pause(name,i){
        console.log('a4l-tmp-bucket/'+name)
        let em = this;
        //sometimes evaporate sets progress mid-Execution of Pause()
        //so we get the value here and set it below
        let pgrs = parseInt(this.videoprogress[i])
        if(pgrs===0)pgrs=1
        this.uploadcontrols[name].pause('a4l-tmp-bucket/'+name, {force: true}) // or 'evaporate.pause()' to pause all
           .then(function () {
             let g = Object.assign({},em.pauseduploads)
             g[name]=true
             em.pauseduploads = g
             em.setVideoProgress({key: i, value: pgrs})
           })
           .catch(function (reason) {
             console.log('Failed to pause:', reason);
           });
      },
      Resume(name,i){
        let em = this;
        this.uploadcontrols[name].resume('a4l-tmp-bucket/'+name) // or 'evaporate.pause()' to pause all
           .then(function () {
             let g = Object.assign({},em.pauseduploads)
             g[name]=false
             em.pauseduploads = g
           })
           .catch(function (reason) {
              console.log('Failed to resume:', reason);
           });
      },
      Cancel (name,i) {
        let em = this;
        this.uploadcontrols[name].cancel('a4l-tmp-bucket/'+name)
                .then(function(){
                  em.setVideoProgress({key: i, value: -1})
                  em.disabled = true
                  console.log(em.uploadcontrols, em.filestoupload)
                })
        console.log(this.uploadcontrols, this.filestoupload)
      },
      savepic (awsKey) {
        /// SET THE PLAYER ID SOMEHOW...
        var em = this
        let args = {
          url: this.$store.state.url + 'api/player',
          method: 'PUT',
          data: {
            partkey: em.$store.state.activeplayer.partkey,
            col: 'info',
            attribute: 'profilepic',
            value: em.$store.state.imgurl + awsKey
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (rdata) {
            console.log(rdata)
            storage.getItem('myplayers').then(function (players) {
              players[args.data.partkey][args.data.attribute] = args.data.value
              storage.setItem('myplayers', players)
              em.$store.commit('myplayers', players)
            })
            var newactiveplayer = em.$store.state.activeplayer
            newactiveplayer.info.profilepic = em.$store.state.imgurl + awsKey
            em.$store.commit('activeplayer', newactiveplayer)
          })
      },
      async getuuid () {
        let res = await this.openGet({path:'unqid'})
        return res.uuid
      },
      clearAll(){
        this.$refs.form.reset()
      },
      async getRecent(){
        this.videos = await this.get({path:'api/video/recent'})
        console.log(this.videos)
      }
    },
  }
</script>


<style scoped>
  .full{
    width:100%;
    text-align: center;
  }
  .fileContainer {
    overflow: hidden;
    position: relative;
  }

  .imgbox{
    height:300px;
    border:solid thin #888888;
    padding-top:100px;
    min-width:300px;
  }
  .imagetoupload{
    width:100%;
    max-width:500px;
  }
  .clearmargin{
    margin:0
  }

  .fileContainer [type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
  }
</style>
